<template>
  <div class="asc-fmdi-header--container">
    <asc-tooltip top :tooltip="getTooltip">
      <div class="asc-fmdi-header--content">
        <div>
          <asc-label size="sm" :value="item.code"></asc-label>
        </div>
        <div class="asc-fmdi-header--value">
          <asc-label size="sm" :value="item.title"></asc-label>
        </div>
      </div>
    </asc-tooltip>
  </div>
</template>

<script>
import AscLabel from '@/components/atoms/AscLabel'
import AscTooltip from '@/components/atoms/AscTooltip'

export default {
  name: 'AscFaultMonitorDetailItemHeader',

  components: { AscLabel, AscTooltip },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    getTooltip() {
      return `${this.item.code} ${this.item.title}`
    },
  },
}
</script>

<style lang="scss">
.asc-fmdi-header--container {
  display: flex;
  width: 100%;

  .asc-fmdi-header--content {
    display: flex;
    width: 100%;
  }

  .asc-fmdi-header--value {
    margin-left: $size-medium;
    min-width: 0;
    word-break: break-all;
  }
}
</style>
